import { DepositGateway, GetDepositGatewayForm } from "store/api/deposit";
import { Grid, Typography, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import { LoadingButton } from "@mui/lab";
import NumberFormats from "components/NumberFormats";
import PriceInput from "components/PriceInput";
import Select from "components/Select";
import http from "config/http";
import { useForm } from "react-hook-form";
import useNotify from "hooks/useNotify";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function PaymentGateway({ selectedWallet }) {
  const notify = useNotify();
  const theme = useTheme()
  
  const [gatewayForm, setGatewayForm] = useState();
  const [loading, setLoading] = useState(false);

  const { watch, setValue, handleSubmit } = useForm({
    defaultValues: { amount: "", bankAccountId: null },
  });
  const amount = watch("amount");
  const bankAccountId = watch("bankAccountId");

  const getDepositGatewayForm = async () => {
    try {
      const { data } = await http.get(GetDepositGatewayForm);

      setGatewayForm(data?.data);
      setValue("bankAccountId", data?.data?.bankAccountId);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getDepositGatewayForm();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (body) => {
    try {
      setLoading(true);

      const { data } = await http.post(DepositGateway, body);

      window.location.href = data?.data?.urlInternetPaymentGateway;
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }

    setLoading(true);
  };

  const isButtonDisabled = useMemo(
    () => !amount || !bankAccountId,
    [amount, bankAccountId]
  );

  return (
    <>
      <Grid item xs={12} my={1}>
        <Typography
          component="h6"
          color="text.main"
          textAlign="right"
          dir="rtl"
        >
          حداقل مقدار واریز: <NumberFormats value={gatewayForm?.minAmount} />
        </Typography>
        <Typography component="h6" color="text.main" textAlign="right">
          کارمزد واریز: {selectedWallet?.depositFeeAmount}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6" color="text.main" fontWeight={400}>
          Banking Accounts
        </Typography>

        <Select
          dir="ltr"
          items={gatewayForm?.lisBankAccount}
          itemValue="id"
          value={bankAccountId}
          customValue={(option) => `${option?.bank} - ${option?.cardNumber}`}
          onChange={(e) => setValue("bankAccountId", e.target.value)}
        />
      </Grid>

      <Grid item xs={12} mt={1}>
        <Typography variant="h6" color="text.main" fontWeight={400}>
          Amount (TOMAN)
        </Typography>

        <PriceInput
          value={amount}
          onChange={(e) => setValue("amount", e)}
          placeholder="لطفا مبلغ مورد نظر را به تومان وارد کنید"
          allowNegative={true}
          maxDecimal={8}
          coinName=""
          max={gatewayForm?.maxAmount}
          min={gatewayForm?.minAmount}
          placeholderPlacement="right"
        />
      </Grid>

      <Grid item xs={12} mt={2}>
        <LoadingButton
          disabled={isButtonDisabled}
          fullWidth
          loading={loading}
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          type="submit"
          color={actionButtonBg(theme)}
        >
          Pay
        </LoadingButton>
      </Grid>
    </>
  );
}

export default PaymentGateway;
